import styled from 'styled-components';

import { LegacyPrimaryButton as PrimaryButton } from 'components/Button/LegacyPrimaryButton';
import { colors, mediaRetina } from 'theme';

export const ButtonGroupButton = styled(PrimaryButton)<{ $selected?: boolean }>`
  position: relative;
  z-index: ${(props) => (props.$selected ? 1 : 0)};
  color: ${(props) =>
    props.$selected ? colors.white : colors.lightContentGrey};
  background-color: ${(props) =>
    props.$selected ? colors.brandBlue : colors.white};
  box-shadow: 0 0 0 1px
    ${(props) => (props.$selected ? colors.brandBlue : colors.elementGrey)}
    inset;
  border-radius: 0;
  &:first-of-type {
    border-radius: 9999px 0 0 9999px;
  }
  &:last-of-type {
    border-radius: 0 9999px 9999px 0;
  }
  &:hover,
  &:focus {
    color: ${colors.white};
    background-color: ${colors.brandBlue};
    box-shadow: 0 0 0 1px ${colors.brandBlue} inset;
  }
  &:focus {
    outline: none;
  }
  ${mediaRetina} {
    box-shadow: 0 0 0 1.5px
      ${(props) => (props.$selected ? colors.brandBlue : colors.elementGrey)}
      inset;
    &:hover,
    &:focus {
      box-shadow: 0 0 0 1.5px ${colors.brandBlue} inset;
    }
  }
`;
